import {
  createBooking,
  getAmenitiesList,
} from "../../../Redux/Bookings/BookingsActions";
import SelectCard from "../../../Components/User/Bookings/SelectCard/SelectCard";
import Agreement from "../../../Components/User/Bookings/Agreement/Agreement";
import { getProfile } from "../../../Redux/Profile/ProfileActions";
import Loading from "../../../Components/Common/Loading/Loading";
import Modal from "../../../Components/Common/Modal/Modal";
import arrowIcon from "../../../Assets/arrowleft.png";
import generateUuid from "../../../Util/generateUuid";
import SignatureCanvas from "react-signature-canvas";
import toastHelper from "../../../Util/toastHelper";
import { AppDispatch } from "../../../Redux/store";
import styles from "./CreateBooking.module.scss";
import { RootState } from "../../../Redux/store";
import { Link, useNavigate } from "react-router";
import validator from "../../../Util/validator";
import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import API from "../../../API/API";
import { useEffect } from "react";
import moment from "moment";
import axios from "axios";

function CreateBooking() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { amenitiesList, createBookingLoading } = useSelector(
    (state: RootState) => state.bookings,
  );
  const { profileData } = useSelector((state: RootState) => state.profile);
  const [amenity, setAmenity] = useState<number | null>(null);
  const [amenityRateType, setAmenityRateType] = useState<string | null>("");
  const [bookingDate, setBookingDate] = useState<string>("");
  const [amenityName, setAmenityName] = useState<string>("");
  const [amenityRate, setAmenityRate] = useState<number | null>(null);
  const [bookingStartDate, setBookingStartDate] = useState<string>("");
  const [bookingEndDate, setBookingEndDate] = useState<string>("");
  const [bookingStartTime, setBookingStartTime] = useState<string>("");
  const [bookingEndTime, setBookingEndTime] = useState<string>("");
  const [isGuest, setIsGuest] = useState<boolean>(false);
  const [bookingDescription, setBookingDescription] = useState<string>("");
  const [voucherCode, setVoucherCode] = useState<string>("");
  const [voucherSuccess, setVoucherSuccess] = useState<any>(null);
  const [agreementModalOpen, setAgreementModalOpen] = useState<boolean>(false);
  const [uuid, setUuid] = useState<string>("");
  const [selectCardModalOpen, setSelectCardModalOpen] =
    useState<boolean>(false);
  const [signature, setSignature] = useState<string>("");
  const [noOfParticipants, setNoOfParticipants] = useState<string>("");
  const [selectedCard, setSelectedCard] = useState<string>("");
  const [termsAndConditions, setTermsAndConditions] = useState<string>("");
  const signRef = useRef<SignatureCanvas | null>(null);
  const [errors, setErrors] = useState<{
    bookingStartTime: string;
    bookingEndTime: string;
    bookingDescription: string;
    bookingDate: string;
    bookingStartDate: string;
    bookingEndDate: string;
    voucherCode: string;
    noOfParticipants: string;
  }>({
    bookingStartTime: "",
    bookingEndTime: "",
    bookingDescription: "",
    bookingDate: "",
    bookingStartDate: "",
    bookingEndDate: "",
    voucherCode: "",
    noOfParticipants: "",
  });

  const applyVoucherHandler = async () => {
    if (voucherCode.trim() !== "") {
      setErrors((prev) => ({
        ...prev,
        voucherCode: "",
      }));
      try {
        const { data } = await axios({
          url: `${API.members.validateVoucher.url}?voucherCode=${voucherCode}&email=${profileData?.member?.email}&voucherType=2`,
          method: API.members.validateVoucher.method,
        });
        setVoucherSuccess(data);
      } catch (error: any) {
        if (error?.response?.data?.message) {
          setErrors((prev) => ({
            ...prev,
            voucherCode: error?.response?.data?.message ?? "",
          }));
        } else {
          setErrors((prev) => ({
            ...prev,
            voucherCode: "Something went wrong",
          }));
        }
      }
    } else {
      setErrors((prev) => ({
        ...prev,
        voucherCode: "Voucher code is required",
      }));
    }
  };

  const removeVoucherHandler = () => {
    setVoucherSuccess(null);
    setVoucherCode("");
  };

  const createBookingHandler = () => {
    if (amenity) {
      if (isGuest) {
        if (amenityRateType === "Per Hour") {
          const { errors: fieldErrors, isValid } = validator([
            {
              key: "bookingStartTime",
              type: "text",
              value: bookingStartTime,
            },
            {
              key: "bookingEndTime",
              type: "text",
              value: bookingEndTime,
            },
            {
              key: "bookingDescription",
              type: "text",
              value: bookingDescription,
            },
            {
              key: "bookingDate",
              type: "date",
              value: bookingDate,
            },
            {
              key: "noOfParticipants",
              type: "text",
              value: noOfParticipants,
            },
          ]);
          setErrors({
            ...errors,
            ...fieldErrors,
          });
          if (isValid) {
            setAgreementModalOpen(true);
          }
        } else if (amenityRateType === "Per Day") {
          const { errors: fieldErrors, isValid } = validator([
            {
              key: "bookingStartDate",
              type: "date",
              value: bookingStartDate,
            },
            {
              key: "bookingEndDate",
              type: "date",
              value: bookingEndDate,
            },
            {
              key: "bookingDescription",
              type: "text",
              value: bookingDescription,
            },
            {
              key: "noOfParticipants",
              type: "text",
              value: noOfParticipants,
            },
          ]);
          setErrors({
            ...errors,
            ...fieldErrors,
          });
          if (isValid) {
            setAgreementModalOpen(true);
          }
        }
      } else {
        if (amenityRateType === "Per Hour") {
          const { errors: fieldErrors, isValid } = validator([
            {
              key: "bookingStartTime",
              type: "text",
              value: bookingStartTime,
            },
            {
              key: "bookingEndTime",
              type: "text",
              value: bookingEndTime,
            },
            {
              key: "bookingDescription",
              type: "text",
              value: bookingDescription,
            },
            {
              key: "bookingDate",
              type: "date",
              value: bookingDate,
            },
          ]);
          setErrors({
            ...errors,
            ...fieldErrors,
          });
          if (isValid) {
            setAgreementModalOpen(true);
          }
        } else if (amenityRateType === "Per Day") {
          const { errors: fieldErrors, isValid } = validator([
            {
              key: "bookingStartDate",
              type: "date",
              value: bookingStartDate,
            },
            {
              key: "bookingEndDate",
              type: "date",
              value: bookingEndDate,
            },
            {
              key: "bookingDescription",
              type: "text",
              value: bookingDescription,
            },
          ]);
          setErrors({
            ...errors,
            ...fieldErrors,
          });
          if (isValid) {
            setAgreementModalOpen(true);
          }
        }
      }
    }
  };

  const agreementHandler = () => {
    if (signRef?.current) {
      if (signRef.current.isEmpty()) {
        toastHelper.error("Please sign the agreement");
      } else {
        setSignature(signRef.current.toDataURL());
        setAgreementModalOpen(false);
        if (amenityRate === 0) {
          withoutCardHandler(signRef.current.toDataURL());
        } else {
          setSelectCardModalOpen(true);
        }
      }
    }
  };

  const selectCardHandler = () => {
    if (selectedCard) {
      const cleanupHandler = () => {
        setSelectCardModalOpen(false);
        setSelectedCard("");
        setAmenity(null);
        setAmenityRateType(null);
        setAmenityName("");
        setAmenityRate(null);
        setBookingStartTime("");
        setBookingEndTime("");
        setBookingDescription("");
        navigate("/bookings", { replace: true });
      };
      if (amenityRateType === "Per Hour") {
        dispatch(
          createBooking({
            MemberCCInfoId: selectedCard,
            content: "Test Test",
            description: bookingDescription,
            amenityId: amenity?.toString() || "",
            startTime: moment(
              `${bookingDate} ${bookingStartTime}`,
              "YYYY-MM-DD HH:mm",
            ).format("YYYY-MM-DDTHH:mm:ss"),
            endTime: moment(
              `${bookingDate} ${bookingEndTime}`,
              "YYYY-MM-DD HH:mm",
            ).format("YYYY-MM-DDTHH:mm:ss"),
            total: calculateTotal() || "",
            signature: signature,
            noOfGuest: isGuest ? noOfParticipants : "0",
            uuid: isGuest ? uuid : "",
            voucherCode: voucherSuccess ? voucherSuccess?.voucher?.name : "",
            cleanupHandler,
          }),
        );
      } else if (amenityRateType === "Per Day") {
        dispatch(
          createBooking({
            MemberCCInfoId: selectedCard,
            content: "Test Test",
            description: bookingDescription,
            amenityId: amenity?.toString() || "",
            startTime: moment(
              `${bookingStartDate} 00:00`,
              "YYYY-MM-DD HH:mm",
            ).format("YYYY-MM-DDTHH:mm:ss"),
            endTime: moment(
              `${bookingEndDate} 23:59`,
              "YYYY-MM-DD HH:mm",
            ).format("YYYY-MM-DDTHH:mm:ss"),
            total: calculateTotal() || "",
            signature: signature,
            noOfGuest: isGuest ? noOfParticipants : "0",
            uuid: isGuest ? uuid : "",
            voucherCode: voucherSuccess ? voucherSuccess?.voucher?.name : "",
            cleanupHandler,
          }),
        );
      }
    } else {
      toastHelper.error("Please select a card");
    }
  };

  const withoutCardHandler = (sig: string) => {
    const cleanupHandler = () => {
      setSelectCardModalOpen(false);
      setSelectedCard("");
      setAmenity(null);
      setAmenityRateType(null);
      setAmenityName("");
      setAmenityRate(null);
      setBookingStartTime("");
      setBookingEndTime("");
      setBookingDescription("");
      navigate("/bookings", { replace: true });
    };
    if (amenityRateType === "Per Hour") {
      dispatch(
        createBooking({
          MemberCCInfoId: null,
          content: "Test Test",
          description: bookingDescription,
          amenityId: amenity?.toString() || "",
          startTime: moment(
            `${bookingDate} ${bookingStartTime}`,
            "YYYY-MM-DD HH:mm",
          ).format("YYYY-MM-DDTHH:mm:ss"),
          endTime: moment(
            `${bookingDate} ${bookingEndTime}`,
            "YYYY-MM-DD HH:mm",
          ).format("YYYY-MM-DDTHH:mm:ss"),
          total: calculateTotal() || "",
          signature: sig,
          noOfGuest: isGuest ? noOfParticipants : "0",
          uuid: isGuest ? uuid : "",
          voucherCode: voucherSuccess ? voucherSuccess?.voucher?.name : "",
          cleanupHandler,
        }),
      );
    } else if (amenityRateType === "Per Day") {
      dispatch(
        createBooking({
          MemberCCInfoId: null,
          content: "Test Test",
          description: bookingDescription,
          amenityId: amenity?.toString() || "",
          startTime: moment(
            `${bookingStartDate} 00:00`,
            "YYYY-MM-DD HH:mm",
          ).format("YYYY-MM-DDTHH:mm:ss"),
          endTime: moment(`${bookingEndDate} 23:59`, "YYYY-MM-DD HH:mm").format(
            "YYYY-MM-DDTHH:mm:ss",
          ),
          total: calculateTotal() || "",
          signature: sig,
          noOfGuest: isGuest ? noOfParticipants : "0",
          uuid: isGuest ? uuid : "",
          voucherCode: voucherSuccess ? voucherSuccess?.voucher?.name : "",
          cleanupHandler,
        }),
      );
    }
  };

  const calculateDuration = () => {
    if (bookingStartTime && bookingEndTime) {
      const start = moment(`2000-01-01 ${bookingStartTime}`);
      const end = moment(`2000-01-01 ${bookingEndTime}`);
      const diffMinutes = end.diff(start, "minutes");

      if (diffMinutes >= 60) {
        const hours = diffMinutes / 60;
        return `${hours.toFixed(1)} hour${hours !== 1 ? "s" : ""}`;
      } else {
        return `${diffMinutes} minute${diffMinutes !== 1 ? "s" : ""}`;
      }
    }
    return null;
  };

  const calculateDateDuration = () => {
    if (bookingStartDate && bookingEndDate) {
      const start = moment(bookingStartDate);
      const end = moment(bookingEndDate);

      if (end.isBefore(start)) {
        return "N/A";
      }

      const diffDays = end.diff(start, "days") + 1;
      return `${diffDays} day${diffDays !== 1 ? "s" : ""}`;
    }
    return null;
  };
  const calculateSubTotal = () => {
    let total = null;

    if (
      amenityRateType === "Per Hour" &&
      amenityRate !== null &&
      bookingStartTime &&
      bookingEndTime
    ) {
      const start = moment(`2000-01-01 ${bookingStartTime}`);
      const end = moment(`2000-01-01 ${bookingEndTime}`);
      const diffMinutes = end.diff(start, "minutes");
      total = (amenityRate * diffMinutes) / 60;
    } else if (
      amenityRateType === "Per Day" &&
      amenityRate !== null &&
      bookingStartDate &&
      bookingEndDate
    ) {
      const start = moment(bookingStartDate);
      const end = moment(bookingEndDate);
      const diffDays = end.diff(start, "days") + 1;
      total = amenityRate * diffDays;
    }

    if (total === null) return null;

    return total.toFixed(2);
  };

  const calculateTotal = () => {
    let total = null;

    if (
      amenityRateType === "Per Hour" &&
      amenityRate !== null &&
      bookingStartTime &&
      bookingEndTime
    ) {
      const start = moment(`2000-01-01 ${bookingStartTime}`);
      const end = moment(`2000-01-01 ${bookingEndTime}`);
      const diffMinutes = end.diff(start, "minutes");
      total = (amenityRate * diffMinutes) / 60;
    } else if (
      amenityRateType === "Per Day" &&
      amenityRate !== null &&
      bookingStartDate &&
      bookingEndDate
    ) {
      const start = moment(bookingStartDate);
      const end = moment(bookingEndDate);
      const diffDays = end.diff(start, "days") + 1;
      total = amenityRate * diffDays;
    }

    if (total === null) return null;

    if (voucherSuccess?.success && voucherSuccess?.voucher) {
      const { percent, maxDiscount } = voucherSuccess.voucher;
      let discountAmount = (total * percent) / 100;

      if (maxDiscount !== null && discountAmount > maxDiscount) {
        discountAmount = maxDiscount;
      }
      total = total - discountAmount;
    }

    return total.toFixed(2);
  };

  const calculateVoucherDiscount = (total: number, voucherSuccess: any) => {
    if (total === null || total === undefined) return 0;
    if (!voucherSuccess?.success || !voucherSuccess?.voucher) return 0;

    const { percent, maxDiscount, isActive, startDate, enddate } =
      voucherSuccess.voucher;

    if (!isActive) return 0;

    const now = moment();

    if (
      (startDate && now.isBefore(moment(startDate))) ||
      (enddate && now.isAfter(moment(enddate)))
    ) {
      return 0;
    }

    const percentValue = Number(percent || 0);
    const percentageDiscount = (Number(total) * percentValue) / 100;

    const discount =
      maxDiscount !== null && maxDiscount !== undefined
        ? Math.min(percentageDiscount, Number(maxDiscount))
        : percentageDiscount;

    return Number(discount.toFixed(2));
  };

  useEffect(() => {
    dispatch(getProfile({ navigate: navigate }));
    dispatch(getAmenitiesList());
    setUuid(generateUuid());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <Modal
        isOpen={agreementModalOpen}
        setIsOpen={setAgreementModalOpen}
        showCloseIcon={false}
      >
        <Agreement signRef={signRef} termsAndConditions={termsAndConditions} />

        <div className={styles.proceedButtonContainer}>
          <button onClick={agreementHandler} className={styles.button}>
            Proceed
          </button>
          <button
            onClick={() => setAgreementModalOpen(false)}
            className={styles.cancelButton}
          >
            Cancel
          </button>
        </div>
      </Modal>

      <Modal
        isOpen={selectCardModalOpen}
        setIsOpen={setSelectCardModalOpen}
        showCloseIcon={false}
      >
        <SelectCard
          selectedCard={selectedCard}
          setSelectedCard={setSelectedCard}
        />

        {createBookingLoading && <Loading />}

        <div className={styles.proceedButtonContainer}>
          <button onClick={selectCardHandler} className={styles.button}>
            Proceed
          </button>
          <button
            onClick={() => setSelectCardModalOpen(false)}
            className={styles.cancelButton}
          >
            Cancel
          </button>
        </div>
      </Modal>

      <div className={styles.mainContainer}>
        <Link to="/bookings" className={styles.backButtonContainer}>
          <button className={styles.button}>
            <img src={arrowIcon} alt="arrowIcon" className={styles.arrowIcon} />
            Back to Bookings
          </button>
        </Link>
        <div className={styles.headingContainer}>
          <h1 className={styles.heading}>Create Booking</h1>
        </div>
        <div className={styles.bookingContainer}>
          <div className={styles.bookingForm}>
            <div className={styles.inputContainer}>
              <p className={styles.label}>Amenity</p>
              <select
                className={styles.input}
                value={amenity || ""}
                onChange={(e) => {
                  setAmenity(Number(e.target.value));
                  const amenity = amenitiesList?.find(
                    (amenity) => amenity.amenityId === Number(e.target.value),
                  );
                  setAmenityRateType(amenity?.rateTypeName);
                  setAmenityName(amenity?.name);
                  setAmenityRate(amenity?.rate);
                  setIsGuest(amenity?.isGuest || false);
                  setTermsAndConditions(amenity?.terms);
                }}
              >
                {!amenity && <option value="">Select Amenity</option>}
                {amenitiesList?.map((amenity) => (
                  <option key={amenity?.amenityId} value={amenity.amenityId}>
                    {amenity.name}
                  </option>
                ))}
              </select>
            </div>

            {amenityRateType === "Per Hour" && (
              <>
                <div className={styles.inputContainer}>
                  <p className={styles.label}>Booking Date</p>
                  <input
                    type="date"
                    className={styles.input}
                    value={bookingDate}
                    onChange={(e) => {
                      const value = e.target.value;

                      if (
                        !moment(value)
                          .startOf("day")
                          .isSameOrAfter(moment().startOf("day"))
                      ) {
                        toastHelper.error(
                          "Booking date must be today or in the future",
                        );
                        return;
                      }
                      setBookingDate(value);
                      const isToday = moment(value).isSame(moment(), "day");
                      if (isToday && bookingStartTime) {
                        const now = moment();
                        const start = moment(bookingStartTime, "HH:mm");

                        if (start.isSameOrBefore(now)) {
                          setBookingStartTime("");
                          setBookingEndTime("");
                        }
                      }
                    }}
                  />
                  <p className={styles.error}>{errors.bookingDate}</p>
                </div>

                <div className={styles.doubleInputContainer}>
                  <div className={styles.inputContainer}>
                    <p className={styles.label}>Booking Start Time</p>
                    <select
                      className={styles.input}
                      value={bookingStartTime}
                      onChange={(e) => {
                        const value = e.target.value;
                        const isToday = moment(bookingDate).isSame(
                          moment(),
                          "day",
                        );

                        if (isToday) {
                          const selectedTime = moment(value, "HH:mm");
                          const currentTime = moment();

                          if (selectedTime.isSameOrBefore(currentTime)) {
                            toastHelper.error(
                              "Start time must be in the future",
                            );
                            return;
                          }
                        }
                        setBookingStartTime(value);
                        if (bookingEndTime) {
                          const start = moment(value, "HH:mm");
                          const end = moment(bookingEndTime, "HH:mm");
                          if (end.isSameOrBefore(start)) {
                            setBookingEndTime("");
                          }
                        }
                      }}
                    >
                      {!bookingStartTime && (
                        <option value="">Select Time</option>
                      )}
                      {Array.from({ length: 48 }, (_, i) => {
                        const hour24 = Math.floor(i / 2);
                        const minute = (i % 2) * 30;

                        let hour12 = hour24 % 12;
                        if (hour12 === 0) hour12 = 12;

                        const period = hour24 < 12 ? "AM" : "PM";

                        const timeString12Hr = `${hour12.toString().padStart(2, "0")}:${minute
                          .toString()
                          .padStart(2, "0")} ${period}`;
                        const timeString24Hr = `${hour24.toString().padStart(2, "0")}:${minute
                          .toString()
                          .padStart(2, "0")}`;

                        return (
                          <option key={timeString24Hr} value={timeString24Hr}>
                            {timeString12Hr}
                          </option>
                        );
                      })}
                    </select>

                    <p className={styles.error}>{errors.bookingStartTime}</p>
                    {calculateDuration() && (
                      <div className={styles.informationContainer}>
                        <p className={styles.informationText}>
                          Booking Duration {calculateDuration()}
                        </p>
                      </div>
                    )}
                  </div>
                  <div className={styles.inputContainer}>
                    <p className={styles.label}>Booking End Time</p>
                    <select
                      className={styles.input}
                      value={bookingEndTime}
                      disabled={!bookingStartTime}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (bookingStartTime) {
                          const start = moment(bookingStartTime, "HH:mm");
                          const end = moment(value, "HH:mm");
                          if (end.isSameOrBefore(start)) {
                            toastHelper.error(
                              "End time must be after start time",
                            );
                            return;
                          }
                        }
                        setBookingEndTime(value);
                      }}
                    >
                      {!bookingEndTime && <option value="">Select Time</option>}
                      {Array.from({ length: 48 }, (_, i) => {
                        const hour24 = Math.floor(i / 2);
                        const minute = (i % 2) * 30;

                        let hour12 = hour24 % 12;
                        if (hour12 === 0) hour12 = 12;

                        const period = hour24 < 12 ? "AM" : "PM";

                        const timeString12Hr = `${hour12.toString().padStart(2, "0")}:${minute
                          .toString()
                          .padStart(2, "0")} ${period}`;
                        const timeString24Hr = `${hour24.toString().padStart(2, "0")}:${minute
                          .toString()
                          .padStart(2, "0")}`;

                        return (
                          <option key={timeString24Hr} value={timeString24Hr}>
                            {timeString12Hr}
                          </option>
                        );
                      })}
                    </select>

                    <p className={styles.error}>{errors.bookingEndTime}</p>
                  </div>
                </div>
              </>
            )}

            {amenityRateType === "Per Day" && (
              <>
                <div className={styles.doubleInputContainer}>
                  <div className={styles.inputContainer}>
                    <p className={styles.label}>Booking Start Date</p>
                    <input
                      type="date"
                      className={styles.input}
                      value={bookingStartDate}
                      onChange={(e) => {
                        if (moment(e.target.value).isAfter(moment())) {
                          if (
                            moment(e.target.value).isAfter(
                              moment(bookingEndDate),
                            )
                          ) {
                            setBookingEndDate(e.target.value);
                            setBookingStartDate(e.target.value);
                          } else {
                            setBookingStartDate(e.target.value);
                          }
                        } else {
                          toastHelper.error(
                            "Booking start date must be in the future",
                          );
                        }
                      }}
                    />
                    <p className={styles.error}>{errors.bookingStartDate}</p>
                    {calculateDateDuration() && (
                      <div className={styles.informationContainer}>
                        <p className={styles.informationText}>
                          Booking Duration {calculateDateDuration()}
                        </p>
                      </div>
                    )}
                  </div>
                  <div className={styles.inputContainer}>
                    <p className={styles.label}>Booking End Date</p>
                    <input
                      type="date"
                      className={styles.input}
                      value={bookingEndDate}
                      min={bookingStartDate}
                      disabled={!bookingStartDate}
                      onChange={(e) => setBookingEndDate(e.target.value)}
                    />
                    <p className={styles.error}>{errors.bookingEndDate}</p>
                  </div>
                </div>
              </>
            )}
            {isGuest && (
              <div className={styles.participantsInputContainer}>
                <p className={styles.label}>No. of participants</p>
                <div className={styles.guestInputDoubleContainer}>
                  <div className={styles.guestInputContainer}>
                    <input
                      type="text"
                      className={styles.input}
                      value={noOfParticipants}
                      maxLength={20}
                      onChange={(e) => {
                        if (/^\d*$/.test(e.target.value)) {
                          setNoOfParticipants(e.target.value);
                        }
                      }}
                    />
                  </div>
                  <div className={styles.guestLinkContainer}>
                    <p className={styles.text}>
                      {window.location.origin}
                      /guest/invites/{uuid}
                    </p>
                    <button
                      className={styles.button}
                      onClick={() => {
                        navigator.clipboard.writeText(
                          window.location.origin + "/guest/invites/" + uuid,
                        );
                        toastHelper.success("Link copied to clipboard");
                      }}
                    >
                      Copy Link
                    </button>
                  </div>
                </div>
                <p className={styles.error}>{errors.noOfParticipants}</p>
              </div>
            )}
            <div
              className={`${styles.inputContainer} ${styles.bookingInputContainer}`}
            >
              <p className={styles.label}>Booking Description</p>
              <input
                type="text"
                className={styles.input}
                value={bookingDescription}
                onChange={(e) => setBookingDescription(e.target.value)}
              />
              <p className={styles.error}>{errors.bookingDescription}</p>
            </div>
          </div>
          {amenityRateType === "Per Hour" && (
            <div className={styles.summaryContainer}>
              <div className={styles.summaryHeader}>
                <h2 className={styles.heading}>Booking Summary</h2>
              </div>
              <div className={styles.summaryBody}>
                <div className={styles.summaryItem}>
                  <p className={styles.label}>Amenity</p>
                  <p className={styles.value}>{amenityName}</p>
                </div>
                <div className={styles.summaryItem}>
                  <p className={styles.label}>Booking Date</p>
                  <p className={styles.value}>
                    {bookingDate
                      ? moment(bookingDate).format("MM/DD/YYYY")
                      : "N/A"}
                  </p>
                </div>
                <div className={styles.summaryItem}>
                  <p className={styles.label}>Booking Start Time</p>
                  <p className={styles.value}>{bookingStartTime || "N/A"}</p>
                </div>
                <div className={styles.summaryItem}>
                  <p className={styles.label}>Booking End Time</p>
                  <p className={styles.value}>{bookingEndTime || "N/A"}</p>
                </div>
                <div className={styles.summaryItem}>
                  <p className={styles.label}>Duration</p>
                  <p className={styles.value}>
                    {calculateDuration() ? `${calculateDuration()}` : "N/A"}
                  </p>
                </div>
                <div className={styles.separator} />
                <div className={styles.summaryItem}>
                  <p className={styles.label}>Per Hour</p>
                  <p className={styles.value}>
                    {amenityRate !== null ? `$${amenityRate}` : "N/A"}
                  </p>
                </div>

                <div className={styles.summaryItem}>
                  <p className={styles.label}>Sub Total</p>
                  <p className={styles.value}>
                    {calculateSubTotal() ? `$${calculateSubTotal()}` : "N/A"}
                  </p>
                </div>
                {!voucherSuccess ? (
                  <div className={styles.couponInputContainer}>
                    <div className={styles.couponInputBox}>
                      <input
                        className={styles.input}
                        type="text"
                        placeholder="Enter Voucher Code"
                        value={voucherCode}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\s/g, "");
                          setVoucherCode(value);
                        }}
                      />
                      <p className={styles.error}>{errors.voucherCode}</p>
                    </div>
                    <button
                      className={styles.button}
                      onClick={applyVoucherHandler}
                    >
                      Apply
                    </button>
                  </div>
                ) : (
                  <div className={styles.couponSuccessContainer}>
                    <p className={styles.heading}>Coupon Applied</p>
                    <div className={styles.voucherContainer}>
                      <p className={styles.voucherCode}>{voucherCode}</p>
                      <p className={styles.voucherDiscount}>
                        -$
                        {calculateVoucherDiscount(
                          Number(calculateSubTotal() || 0),
                          voucherSuccess,
                        )}
                      </p>
                    </div>
                    <div className={styles.buttonContainer}>
                      <button
                        className={styles.button}
                        onClick={removeVoucherHandler}
                      >
                        Remove Voucher
                      </button>
                    </div>
                  </div>
                )}
                <div className={styles.summaryItem}>
                  <p className={styles.label}>Total</p>
                  <p className={styles.value}>
                    {calculateTotal() ? `$${calculateTotal()}` : "N/A"}
                  </p>
                </div>
                <div className={styles.buttonContainer}>
                  <button
                    onClick={createBookingHandler}
                    className={styles.button}
                  >
                    Create Booking
                  </button>
                </div>
              </div>
            </div>
          )}

          {amenityRateType === "Per Day" && (
            <div className={styles.summaryContainer}>
              <div className={styles.summaryHeader}>
                <h2 className={styles.heading}>Booking Summary</h2>
              </div>
              <div className={styles.summaryBody}>
                <div className={styles.summaryItem}>
                  <p className={styles.label}>Amenity</p>
                  <p className={styles.value}>{amenityName}</p>
                </div>
                <div className={styles.summaryItem}>
                  <p className={styles.label}>Booking Start Date</p>
                  <p className={styles.value}>
                    {bookingStartDate
                      ? moment(bookingStartDate).format("MM/DD/YYYY")
                      : "N/A"}
                  </p>
                </div>
                <div className={styles.summaryItem}>
                  <p className={styles.label}>Booking End Date</p>
                  <p className={styles.value}>
                    {bookingEndDate
                      ? moment(bookingEndDate).format("MM/DD/YYYY")
                      : "N/A"}
                  </p>
                </div>

                <div className={styles.summaryItem}>
                  <p className={styles.label}>Duration</p>
                  <p className={styles.value}>
                    {calculateDateDuration()
                      ? `${calculateDateDuration()}`
                      : "N/A"}
                  </p>
                </div>
                <div className={styles.separator} />
                <div className={styles.summaryItem}>
                  <p className={styles.label}>Per Day</p>
                  <p className={styles.value}>
                    {amenityRate !== null ? `$${amenityRate}` : "N/A"}
                  </p>
                </div>
                <div className={styles.summaryItem}>
                  <p className={styles.label}>Sub Total</p>
                  <p className={styles.value}>
                    {calculateSubTotal() ? `$${calculateSubTotal()}` : "N/A"}
                  </p>
                </div>
                {!voucherSuccess ? (
                  <div className={styles.couponInputContainer}>
                    <div className={styles.couponInputBox}>
                      <input
                        className={styles.input}
                        type="text"
                        placeholder="Enter Voucher Code"
                        value={voucherCode}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\s/g, "");
                          setVoucherCode(value);
                        }}
                      />
                      <p className={styles.error}>{errors.voucherCode}</p>
                    </div>
                    <button
                      className={styles.button}
                      onClick={applyVoucherHandler}
                    >
                      Apply
                    </button>
                  </div>
                ) : (
                  <div className={styles.couponSuccessContainer}>
                    <p className={styles.heading}>Coupon Applied</p>
                    <div className={styles.voucherContainer}>
                      <p className={styles.voucherCode}>{voucherCode}</p>
                      <p className={styles.voucherDiscount}>
                        -$
                        {voucherSuccess?.voucher?.maxDiscount}
                      </p>
                    </div>
                    <div className={styles.buttonContainer}>
                      <button
                        className={styles.button}
                        onClick={removeVoucherHandler}
                      >
                        Remove Voucher
                      </button>
                    </div>
                  </div>
                )}
                <div className={styles.summaryItem}>
                  <p className={styles.label}>Total</p>
                  <p className={styles.value}>
                    {calculateTotal() ? `$${calculateTotal()}` : "N/A"}
                  </p>
                </div>
                <div className={styles.buttonContainer}>
                  <button
                    onClick={createBookingHandler}
                    className={styles.button}
                  >
                    Create Booking
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default CreateBooking;
